import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mail",
  "use": "icon-mail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-mail\"><path d=\"M0 3v18h24V3zm21.518 2L12 12.713 2.482 5zM2 19V7.183l10 8.104 10-8.104V19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol